import { render, staticRenderFns } from "./space_date_price.vue?vue&type=template&id=13fc06cc&scoped=true"
import script from "./space_date_price.vue?vue&type=script&lang=js"
export * from "./space_date_price.vue?vue&type=script&lang=js"
import style0 from "./space_date_price.vue?vue&type=style&index=0&id=13fc06cc&prod&scoped=true&lang=css"
import style1 from "./space_date_price.vue?vue&type=style&index=1&id=13fc06cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc06cc",
  null
  
)

export default component.exports